import React, { useEffect, useState } from 'react';

import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';

import * as S from './styles';
import { CircularProgress } from '@material-ui/core';

type ThumbnailViewerProps = {
  fileUrl: string;
};

export function ThumbnailViewer({ fileUrl }: ThumbnailViewerProps) {
  const [thumbnail, setThumbnail] = useState<string | null>(null);
  const [loading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    const loadThumbnail = async () => {
      try {
        const loadingTask = pdfjsLib.getDocument(fileUrl);
        const pdf = await loadingTask.promise;

        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 0.5 });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d')!;
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
          canvasContext: context,
          viewport,
        }).promise;

        const dataUrl = canvas.toDataURL();
        setThumbnail(dataUrl);
      } catch (error) {
        console.error('Erro ao gerar thumbnail do PDF:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadThumbnail();
  }, [fileUrl]);

  if (loading) {
    return (
      <S.LoadingOverlay>
        <CircularProgress color="primary" />
      </S.LoadingOverlay>
    );
  }

  if (!thumbnail) return null;

  return <img src={thumbnail} alt="Miniatura do PDF" width={'100%'} />;
}
